<template>
    <div class="algorithm-page">
      <section class="page-hero">
        <div class="container">
          <div class="hero-content">
            <div class="hero-image">
              <img src="https://tsyyapi.dctechonline.cn/static/images/p2.jpg" alt="算法课程"/>
            </div>
            <div class="hero-info">
              <h1 class="page-title">算法课程体系</h1>
              <p class="page-desc">从数据结构到算法设计，系统化培养计算思维与问题解决能力</p>
              
              <div class="level-cards">
                <div class="level-card" v-for="(level, index) in levels" :key="index">
                  <div class="level-header">
                    <h3 class="level-title">{{ level.title }}</h3>
                    <span class="level-age">{{ level.age }}</span>
                  </div>
                  <p class="level-desc">{{ level.desc }}</p>
                </div>
              </div>
              
              <div class="cta-button">
                <button class="btn btn-primary btn-lg" @click="toClass()">
                  <span>进入算法课堂</span>
                  <span class="btn-icon">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="curriculum-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">课程大纲</h2>
            <p class="section-subtitle">系统化的课程设计，循序渐进提升编程能力</p>
          </div>

          <div class="curriculum-grid">
            <div class="curriculum-card">
              <div class="card-header">
                <div class="card-icon">📊</div>
                <h3 class="card-title">数据结构课程</h3>
              </div>
              <ul class="curriculum-list">
                <li v-for="(item, index) in dataStructureCourses" :key="index">
                  <span class="lesson-number">{{ index + 1 }}</span>
                  <span class="lesson-title">{{ item }}</span>
                </li>
              </ul>
            </div>

            <div class="curriculum-card">
              <div class="card-header advanced">
                <div class="card-icon">🧮</div>
                <h3 class="card-title">算法课程</h3>
              </div>
              <ul class="curriculum-list">
                <li v-for="(item, index) in algorithmCourses" :key="index">
                  <span class="lesson-number">{{ index + 1 }}</span>
                  <span class="lesson-title">{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="teachers-section">
        <div class="container">
          <div class="teachers-content">
            <div class="teachers-text">
              <h2 class="section-title text-left">教学师资</h2>
              <p class="teachers-desc">
                团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。
              </p>
              <p class="teachers-highlight">
                首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。
              </p>
              <div class="teacher-tags">
                <span class="tag">985高校</span>
                <span class="tag">计算机专业</span>
                <span class="tag">丰富经验</span>
              </div>
            </div>
            <div class="teachers-image">
              <img src="/images/teach.jpg" alt="教学团队"/>
            </div>
          </div>
        </div>
      </section>

      <section class="cta-section">
        <div class="container">
          <div class="cta-content">
            <div class="cta-image">
              <img src="/images/back2.jpg" alt="开始学习"/>
            </div>
            <div class="cta-text">
              <h2 class="cta-title">我要上课</h2>
              <p class="cta-desc">联系课程顾问获取课程价格以及上课方式</p>
              <div class="cta-qr">
                <img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" alt="扫码咨询"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <bottom></bottom>
    </div>
</template>

<script>
import bottom from '@/components/bottom.vue'

export default{
    components:{
        bottom
    },
    data() {
      return {
        levels: [
          { title: '数据结构', age: '10-15岁', desc: '讲解编程中常用的数据结构。适合有一定C++编程基础，想要在编程领域更进一步以及希望参加编程竞赛的同学' },
          { title: '算法', age: '10-16岁', desc: '讲解编程中常用的基本算法，适合有一定C++编程基础，想要在编程领域更进一步以及希望参加编程竞赛的同学' }
        ],
        dataStructureCourses: [
          '链表',
          '栈',
          '队列',
          '二叉树的概念',
          '二叉树的应用',
          '图的基本概念',
          '图的应用（一）',
          '图的应用（二）',
          '散列表和集合',
          '数据结构综合应用'
        ],
        algorithmCourses: [
          '时间复杂度与进制转换',
          '查找算法',
          '枚举法，递推法',
          '简单排序算法',
          '贪心算法',
          '回溯算法',
          '分治算法：快速排序与归并排序',
          '动态规划算法',
          '算法中的编码与数学知识',
          '算法的综合运用'
        ]
      }
    },
    methods:{
        toClass(){
            this.$router.push('/algorithm-class')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.algorithm-page {
  background: $bg-secondary;
}

.page-hero {
  padding: 120px 0 80px;
  background: white;
  
  @include responsive(md) {
    padding: 100px 0 60px;
  }
}

.hero-content {
  display: flex;
  align-items: flex-start;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.hero-image {
  flex: 0 0 40%;
  
  img {
    width: 100%;
    border-radius: $border-radius-xl;
    box-shadow: $shadow-lg;
  }
  
  @include responsive(md) {
    flex: 1;
    width: 100%;
  }
}

.hero-info {
  flex: 1;
}

.page-title {
  font-size: 42px;
  font-weight: 800;
  color: $text-primary;
  margin-bottom: 12px;
  
  @include responsive(md) {
    font-size: 32px;
  }
}

.page-desc {
  font-size: 18px;
  color: $text-secondary;
  margin-bottom: 32px;
  
  @include responsive(md) {
    font-size: 16px;
  }
}

.level-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 32px;
  
  @include responsive(md) {
    grid-template-columns: 1fr;
  }
}

.level-card {
  padding: 24px;
  background: $bg-secondary;
  border-radius: $border-radius-lg;
  border: 1px solid transparent;
  transition: all $transition;
  
  &:hover {
    border-color: rgba($primary-color, 0.3);
    box-shadow: $shadow;
    transform: translateY(-4px);
  }
}

.level-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.level-title {
  font-size: 18px;
  font-weight: 600;
  color: $text-primary;
}

.level-age {
  padding: 4px 12px;
  background: $bg-gradient;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.level-desc {
  font-size: 14px;
  color: $text-secondary;
  line-height: 1.6;
}

.cta-button {
  margin-top: 24px;
  
  .btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 32px;
    font-size: 16px;
    
    .btn-icon {
      transition: transform $transition;
    }
    
    &:hover .btn-icon {
      transform: translateX(4px);
    }
  }
}

.curriculum-section {
  padding: 80px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 12px;
  
  @include responsive(md) {
    font-size: 28px;
  }
  
  &.text-left {
    text-align: left;
  }
}

.section-subtitle {
  font-size: 16px;
  color: $text-secondary;
}

.curriculum-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  
  @include responsive(md) {
    grid-template-columns: 1fr;
  }
}

.curriculum-card {
  background: white;
  border-radius: $border-radius-lg;
  overflow: hidden;
  box-shadow: $shadow;
  
  .card-header {
    padding: 24px;
    background: $bg-gradient;
    display: flex;
    align-items: center;
    gap: 12px;
    
    &.advanced {
      background: linear-gradient(135deg, $secondary-color 0%, #4f46e5 100%);
    }
    
    .card-icon {
      font-size: 28px;
    }
    
    .card-title {
      font-size: 20px;
      font-weight: 600;
      color: white;
      margin: 0;
    }
  }
}

.curriculum-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 500px;
  overflow-y: auto;
  
  @include scroll-style;
  
  li {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 24px;
    border-bottom: 1px solid $border-color;
    transition: all $transition-fast;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background: rgba($primary-color, 0.05);
      padding-left: 32px;
    }
  }
  
  .lesson-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: $bg-secondary;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: $text-secondary;
    flex-shrink: 0;
  }
  
  .lesson-title {
    font-size: 14px;
    color: $text-primary;
  }
}

.teachers-section {
  padding: 80px 0;
  background: white;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.teachers-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.teachers-text {
  flex: 1;
  
  .section-title {
    text-align: left;
    margin-bottom: 24px;
  }
}

.teachers-desc {
  font-size: 16px;
  color: $text-secondary;
  line-height: 1.8;
  margin-bottom: 16px;
}

.teachers-highlight {
  font-size: 16px;
  color: $primary-color;
  font-weight: 500;
  margin-bottom: 24px;
}

.teacher-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.tag {
  padding: 8px 16px;
  background: rgba($primary-color, 0.1);
  color: $primary-color;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.teachers-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-section {
  padding: 80px 0;
  background: $bg-secondary;
  
  @include responsive(md) {
    padding: 60px 0;
  }
}

.cta-content {
  display: flex;
  align-items: center;
  gap: 60px;
  
  @include responsive(md) {
    flex-direction: column;
    gap: 40px;
  }
}

.cta-image {
  flex: 1;
  
  img {
    width: 100%;
    border-radius: $border-radius-lg;
    box-shadow: $shadow-lg;
  }
}

.cta-text {
  flex: 1;
}

.cta-title {
  font-size: 32px;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 16px;
  
  @include responsive(md) {
    font-size: 28px;
    text-align: center;
  }
}

.cta-desc {
  font-size: 16px;
  color: $text-secondary;
  margin-bottom: 24px;
  
  @include responsive(md) {
    text-align: center;
  }
}

.cta-qr {
  display: inline-block;
  padding: 16px;
  background: white;
  border-radius: $border-radius-lg;
  box-shadow: $shadow;
  
  @include responsive(md) {
    display: block;
    text-align: center;
  }
  
  img {
    max-width: 180px;
    border-radius: $border-radius;
  }
}
</style>
